import React from "react"
import FieldProto_AutomationActionForm from "../../../../../proto/render/automation/automation-action-form";
import SelectGenericNew from "../../../../../../gd-ui/select-generic-new/select-generic-new";
import FieldStatus_DropdownValueNotEmpty from "../../../../../generic/status/components/dropdown/value-not-empty";
import FieldStatus_DropdownOption from "../../../../../generic/status/components/dropdown/popover-option";

export default class FieldTaskStatus_AutomationActionForm extends FieldProto_AutomationActionForm {

    onChangeToValue     = (option:any)  => {
        const toValue = option ? option.value : null
        this.props.onChangeCallback({toValue})
    }

    render() {

        // const model = {
        //     [this.props.field.fieldId]: this.props.config.toValue
        // }
        const options = gd.session.statuses.toOptions()

        return (
            <div className="flex-row-left-top">
                <div className="label">to</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {options}
                                  value                         = {this.props.config.toValue}
                                  popoverScrollContainerClasses = "max-h-200 max-w-200"
                                  valueComponent                = {FieldStatus_DropdownValueNotEmpty}
                                  popoverOptionComponent        = {FieldStatus_DropdownOption}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }

}